<div class="review-changes-container">
    <div class="review-page-header">
        <h3>Submission Status - {{ approvalData?.well_name }}</h3>
        <div class="sub-header">Operation completed successfully | Changes submitted for approval</div>
    </div>

    <div class="review-content-scroll">
        <!-- Loading State -->
        <div *ngIf="loading" class="loading-state">
            <div class="spinner"></div>
            <p>Processing submission...</p>
        </div>

        <!-- Executing State -->
        <div *ngIf="isExecuting" class="loading-state">
            <div class="spinner"></div>
            <p>Executing changes to WellView...</p>
        </div>

        <!-- Execution Result -->
        <div *ngIf="!isExecuting && executionResult" class="execution-result">
            <div class="success-banner" *ngIf="executionResult.status === 'completed'">
                <span class="material-icons success-icon">check_circle</span>
                <div class="success-content">
                    <h4>Execution Completed Successfully</h4>
                    <p>{{ executionResult.well_name }} - {{ executionResult.bu }}</p>
                </div>
            </div>

            <div class="summary-cards" *ngIf="executionResult.summary">
                <div class="summary-card">
                    <span class="material-icons">assignment</span>
                    <div class="card-content">
                        <div class="card-value">{{ executionResult.summary.total }}</div>
                        <div class="card-label">Total Operations</div>
                    </div>
                </div>
                <div class="summary-card">
                    <span class="material-icons">check_circle</span>
                    <div class="card-content">
                        <div class="card-value">{{ executionResult.summary.successful }}</div>
                        <div class="card-label">Successful</div>
                    </div>
                </div>
                <div class="summary-card">
                    <span class="material-icons">error</span>
                    <div class="card-content">
                        <div class="card-value">{{ executionResult.summary.failed }}</div>
                        <div class="card-label">Failed</div>
                    </div>
                </div>
            </div>

            <!-- Execution Results Details -->
            <div class="operations-section" *ngIf="executionResult.results">
                <div class="section-header">
                    <span class="material-icons">list_alt</span>
                    <h4>Execution Results</h4>
                </div>

                <div class="operation-card" *ngFor="let result of executionResult.results; let i = index">
                    <div class="operation-header">
                        <div class="operation-title">
                            <span class="operation-badge" [class.badge-success]="result.status === 'success'"
                                                          [class.badge-error]="result.status !== 'success'">
                                {{ result.status }}
                            </span>
                            <span class="operation-label">{{ getOperationLabel(result, i) }}</span>
                        </div>
                        <span class="record-id">{{ getActionLabel(result.action) }}</span>
                    </div>

                    <div class="operation-content">
                        <!-- Show fields_updated for PUT or fields_created for POST if available -->
                        <div class="field-updates-section" *ngIf="(result.fields_updated && result.fields_updated.length > 0) || (result.fields_created && result.fields_created.length > 0)">
                            <div class="subsection-title-group">
                                <span class="material-icons">edit</span>
                                <h5 class="subsection-title">{{ getFieldsSectionTitle(result.action) }}</h5>
                            </div>
                            <!-- Display as bullet points instead of cards -->
                            <ul class="fields-bullet-list">
                                <li *ngFor="let field of result.fields_updated || result.fields_created || []">
                                    <span *ngIf="!isUnitVariantKey(field)">{{ getDisplayLabel(field) }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Success Summary -->
        <div *ngIf="!loading && !isExecuting && !executionResult && approvalData" class="success-summary">
            <div class="success-banner">
                <span class="material-icons success-icon">check_circle</span>
                <div class="success-content">
                    <h4>{{ approvalData.message || 'Submission Successful' }}</h4>
                    <p>{{ approvalData.well_name }} - {{ approvalData.bu }}</p>
                </div>
            </div>

            <div class="summary-cards" *ngIf="approvalData.operations">
                <div class="summary-card">
                    <span class="material-icons">assignment</span>
                    <div class="card-content">
                        <div class="card-value">{{ approvalData.operations?.length || 0 }}</div>
                        <div class="card-label">Total Operations</div>
                    </div>
                </div>
            </div>

            <!-- Upload Status -->
            <div class="upload-status" *ngIf="approvalData?.adls_upload">
                <div class="status-header">
                    <span class="material-icons">cloud_upload</span>
                    <h4>Data Lake Upload</h4>
                </div>
                <div class="status-details">
                    <div class="status-row">
                        <span class="status-label">Status:</span>
                        <span class="status-value success">
                            <span class="material-icons">check</span>
                            {{ approvalData.adls_upload.status }}
                        </span>
                    </div>
                    <div class="status-row">
                        <span class="status-label">File Path:</span>
                        <span class="status-value">{{ approvalData.adls_upload.file_path }}</span>
                    </div>
                    <div class="status-row">
                        <span class="status-label">File Size:</span>
                        <span class="status-value">{{ approvalData.adls_upload.size_bytes }} bytes</span>
                    </div>
                </div>
            </div>

            <!-- Operations Details -->
            <div class="operations-section">
                <div class="section-header">
                    <span class="material-icons">list_alt</span>
                    <h4>Operation Details</h4>
                </div>

                        <div class="operation-card" *ngFor="let operation of approvalData?.operations; let i = index">
                    <div class="operation-header">
                        <div class="operation-title">
                            <span class="operation-badge" [class.badge-put]="operation.action === 'PUT'"
                                                          [class.badge-post]="operation.action === 'POST'"
                                                          [class.badge-delete]="operation.action === 'DELETE'">
                                {{ getActionLabel(operation.action) }}
                            </span>
                            <span class="operation-label">{{ getOperationLabel(operation, i) }}</span>
                        </div>
                        <span class="record-id" *ngIf="operation.content?.idrec" title="{{ operation.content.idrec }}">ID: {{ operation.content.idrec.substring(0, 8) }}...</span>
                    </div>

                    <div class="operation-content">
                        <!-- Show fields_to_update for PUT or fields_created for POST if available -->
                        <div class="field-updates-section" *ngIf="(operation.metadata?.fields_to_update && operation.metadata.fields_to_update.length > 0) || (operation.metadata?.fields_created && operation.metadata.fields_created.length > 0)">
                            <div class="subsection-title-group">
                                <span class="material-icons">edit</span>
                                <h5 class="subsection-title">{{ getFieldsSectionTitle(operation.action) }}</h5>
                            </div>
                            <div class="field-updates-grid">
                                <div class="field-update-item" *ngFor="let field of operation.metadata?.fields_to_update || operation.metadata?.fields_created || []">
                                    <div *ngIf="!isUnitVariantKey(field)">
                                        <div class="field-header">
                                            <div class="field-name">{{ getDisplayLabel(field) }}</div>
                                            <!-- Show toggle for fields with unit conversions -->
                                            <div class="unit-toggle-inline" *ngIf="hasUnitVariants(field, operation)">
                                                <button 
                                                    *ngFor="let unit of getAvailableUnits(field, operation)"
                                                    class="unit-btn-inline" 
                                                    [class.active]="getSelectedUnit('operation-' + i, field, operation) === unit"
                                                    (click)="setSelectedUnit(unit, 'operation-' + i, field)"
                                                    [title]="'Show values in ' + getUnitDisplayLabel(unit)">
                                                    {{ getUnitDisplayLabel(unit) }}
                                                </button>
                                            </div>
                                        </div>
                                        <div class="field-value" *ngIf="getValueForOperationField(operation, field, 'operation-' + i) !== null">
                                            <span class="value-badge">{{ getValueForOperationField(operation, field, 'operation-' + i) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Fallback: Show all content fields if fields_to_update is not available -->
                        <div class="field-updates-section" *ngIf="!operation.metadata?.fields_to_update || operation.metadata.fields_to_update.length === 0">
                            <div class="subsection-title-group">
                                <span class="material-icons">edit</span>
                                <h5 class="subsection-title">{{ getFieldsSectionTitle(operation.action) }}</h5>
                            </div>
                            <div class="field-updates-grid">
                                <div class="field-update-item" *ngFor="let key of getContentKeys(operation)">
                                    <div *ngIf="!isUnitVariantKey(key)">
                                        <div class="field-header">
                                            <div class="field-name">{{ getDisplayLabel(key) }}</div>
                                            <!-- Show toggle for fields with unit conversions -->
                                            <div class="unit-toggle-inline" *ngIf="hasUnitVariants(key, operation)">
                                                <button 
                                                    *ngFor="let unit of getAvailableUnits(key, operation)"
                                                    class="unit-btn-inline" 
                                                    [class.active]="getSelectedUnit('operation-' + i, key) === unit"
                                                    (click)="setSelectedUnit(unit, 'operation-' + i, key)"
                                                    [title]="'Show values in ' + getUnitDisplayLabel(unit)">
                                                    {{ getUnitDisplayLabel(unit) }}
                                                </button>
                                            </div>
                                        </div>
                                        <div class="field-value" *ngIf="operation.content[key] !== null && operation.content[key] !== undefined">
                                            <span class="value-badge">{{ formatValue(key, operation.content[key]) }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="metadata-section" *ngIf="operation.metadata?.middleware_record">
                            <h5 class="subsection-title">
                                <span class="material-icons">info</span>
                                Middleware Record Details
                            </h5>
                            <div class="metadata-grid">
                                <div class="metadata-item" *ngIf="operation.metadata.middleware_record.WellName">
                                    <span class="metadata-label">Well Name:</span>
                                    <span class="metadata-value">{{ operation.metadata.middleware_record.WellName }}</span>
                                </div>
                                <div class="metadata-item" *ngIf="operation.metadata.middleware_record['API Number']">
                                    <span class="metadata-label">API Number:</span>
                                    <span class="metadata-value">{{ operation.metadata.middleware_record['API Number'] }}</span>
                                </div>
                                <div class="metadata-item" *ngIf="operation.metadata.middleware_record['Operator Name']">
                                    <span class="metadata-label">Operator:</span>
                                    <span class="metadata-value">{{ operation.metadata.middleware_record['Operator Name'] }}</span>
                                </div>
                                <div class="metadata-item" *ngIf="operation.metadata.middleware_record.DateTime">
                                    <span class="metadata-label">Date Time:</span>
                                    <span class="metadata-value">{{ operation.metadata.middleware_record.DateTime }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Well View Data Section (Collapsible) -->
            <div class="well-view-section">
                <div class="well-view-header">
                    <button class="btn-toggle-view" (click)="toggleWellViewData()">
                        <span class="material-icons">{{ showWellViewData ? 'expand_less' : 'expand_more' }}</span>
                        <span>{{ showWellViewData ? 'Hide' : 'View' }} Well View Data</span>
                    </button>
                </div>

                <div class="well-view-content" [@slideDown]="showWellViewData ? 'expanded' : 'collapsed'" *ngIf="showWellViewData">
                    <!-- Loading State -->
                    <div *ngIf="wellViewDataLoading" class="well-view-loading">
                        <div class="table-wrapper">
                            <table class="data-table skeleton-table vertical-headers">
                                <tbody>
                                    <tr *ngFor="let i of [1,2,3,4,5,6,7,8]">
                                        <th>
                                            <div class="skeleton-cell"></div>
                                        </th>
                                        <td *ngFor="let j of [1,2]">
                                            <div class="skeleton-cell"></div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- Well View Data Table -->
                    <div *ngIf="!wellViewDataLoading && wellViewData && wellViewData.length > 0" class="well-view-data-wrapper">
                        <div class="section-header">
                            <div class="header-left">
                                <span class="material-icons">visibility</span>
                                <h4>Well View Data</h4>
                                <span class="record-count">{{ wellViewData.length }} record(s)</span>
                            </div>
                        </div>
                        <div class="table-wrapper">
                            <table class="data-table vertical-headers">
                                <tbody>
                                    <tr *ngFor="let key of getWellViewDisplayKeys(); let i = index">
                                        <th *ngIf="!isUnitVariantKey(key)">
                                            <div class="th-header">
                                                <span>{{ getDisplayLabel(key) }}</span>
                                                <!-- Show toggle only for fields with unit variants -->
                                                <div class="unit-toggle-inline" *ngIf="wellViewData.length > 0 && hasUnitVariants(key, wellViewData[0])">
                                                    <button 
                                                        *ngFor="let unit of getAvailableUnits(key, wellViewData[0])"
                                                        class="unit-btn-inline" 
                                                        [class.active]="getSelectedUnit('wellview', key) === unit"
                                                        (click)="setSelectedUnit(unit, 'wellview', key)"
                                                        [title]="'Show values in ' + getUnitDisplayLabel(unit)">
                                                        {{ getUnitDisplayLabel(unit) }}
                                                    </button>
                                                </div>
                                            </div>
                                        </th>
                                        <td *ngFor="let record of wellViewData; let j = index" [hidden]="isUnitVariantKey(key)">
                                            {{ formatValue(key, getValueForUnit(record, key, 'wellview')) }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <!-- No Data Message -->
                    <div *ngIf="!wellViewDataLoading && (!wellViewData || wellViewData.length === 0)" class="no-data-message">
                        <span class="material-icons">info</span>
                        <p>No Well View data available</p>
                    </div>

                    <!-- Error Message -->
                    <div *ngIf="!wellViewDataLoading && wellViewDataError" class="error-message">
                        <span class="material-icons">error</span>
                        <p>{{ wellViewDataError }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="footer-actions">
        <button class="btn btn-secondary" (click)="onBackToList()" [disabled]="isExecuting">
            <span class="material-icons">arrow_back</span>
            Back to List
        </button>
        <button class="btn btn-success" (click)="onExecute()" 
                [disabled]="isExecuting || isExecuted || !approvalData"
                *ngIf="!executionResult">
            <span class="material-icons">play_arrow</span>
            {{ isExecuting ? 'Executing...' : 'Execute' }}
        </button>
        <!-- Disabling condition temporarily disabled for testing: [disabled]="isExecuting" -->
        <button class="btn btn-primary" (click)="onGoToNextSchema()" [disabled]="false" *ngIf="executionResult">
            <span class="material-icons">arrow_forward</span>
            Go to Next Schema
        </button>
    </div>
</div>
